/* members.api — Organization member management endpoints.
   All paths are nested under /orgs/:orgId/members. */
import { get, post, patch, del } from './client.js';

const base = (orgId) => `/orgs/${orgId}/members`;

export const list = (orgId, params = {}) => {
  const qs = new URLSearchParams();
  if (params.search)   qs.set('search',   params.search);
  if (params.status)   qs.set('status',   params.status);
  if (params.role)     qs.set('role',     params.role);
  if (params.page)     qs.set('page',     String(params.page));
  if (params.pageSize) qs.set('pageSize', String(params.pageSize));
  if (params.sort)     qs.set('sort',     params.sort);      // LOW-07
  if (params.sortDir)  qs.set('sortDir',  params.sortDir);   // LOW-07
  const q = qs.toString();
  return get(`${base(orgId)}${q ? '?' + q : ''}`);
};

export const getOne    = (orgId, memberId)       => get(`${base(orgId)}/${memberId}`);
export const invite       = (orgId, body)          => post(`${base(orgId)}/invite`, body);
export const batchInvite  = (orgId, members)       => post(`${base(orgId)}/batch-invite`, { members });
export const update        = (orgId, memberId, body)  => patch(`${base(orgId)}/${memberId}`, body);
export const updateProfile = (orgId, memberId, body)  => patch(`${base(orgId)}/${memberId}/profile`, body);
export const activate  = (orgId, memberId)        => post(`${base(orgId)}/${memberId}/activate`);
export const suspend   = (orgId, memberId)        => post(`${base(orgId)}/${memberId}/suspend`);
export const remove    = (orgId, memberId)        => del(`${base(orgId)}/${memberId}`);
export const sessions     = (orgId, memberId)       => get(`${base(orgId)}/${memberId}/sessions`);
export const resendInvite = (orgId, memberId)       => post(`${base(orgId)}/${memberId}/resend-invite`);
export const cancelInvite = (orgId, memberId)       => post(`${base(orgId)}/${memberId}/cancel-invite`);
export const forceLogout       = (orgId, memberId) => del(`${base(orgId)}/${memberId}/sessions`);
export const sendPasswordReset = (orgId, memberId) => post(`${base(orgId)}/${memberId}/send-password-reset`);
